<div class="page-configurator-success">
   <div class="container">
      <div class="row">
         <div class="col-lg-12">
            <div class="buttons-top desktop">
               <div *ngIf="!cadastroSalvo" class="back-configurator">
                  <div class="button">
                     <a [routerLink]="['/decorar-apartamento']"><img alt='Seta' src='assets/images/arrow-left-black.png' /> Voltar para o configurador</a>
                  </div>
               </div>
               <div *ngIf="cadastroSalvo" class="back-configurator">
                  <div class="button">
                     <a [routerLink]="['/decorar-apartamento', cliente.codigoUrl]"><img alt='Seta' src='assets/images/arrow-left-black.png' /> Voltar para o configurador</a>
                  </div>
               </div>
               <!--
               <div class="price">
                  <div class="desc-total">Valor total:</div>
                  <div class="val-total">{{cliente.valorTotal | currency: 'BRL': true}}</div>
               </div>
               -->
            </div>
         </div>
         <div class="content">
            <div stickySidebar containerSelector=".content" innerWrapperSelector=".sidebar__inner" topSpacing="150">
               <div class="col-lg-6 sidebar__inner">
                  <div class="image-room">
                     <owl-carousel-o [options]="carouselOptions">
                        <ng-template *ngFor="let comodo of getComodosSemCozinha()" carouselSlide>
                           <div>
                              <img class="background-image base" src="{{caminhoImg+comodo.imagem}}" alt="{{comodo.nome}}">
                              <div *ngFor="let comodoAtributoVariacao of getComodoVariacoes(comodo.id)">
                                 <img *ngIf="!comodoAtributoVariacao.nome.includes('Cor Formica')" class="background-image" src="{{caminhoImg+comodoAtributoVariacao.imagem}}" alt="{{comodoAtributoVariacao.nome}}">
                                 <div *ngIf="comodoAtributoVariacao.imagem && comodoAtributoVariacao.nome.includes('Cor Formica')" class="background-image svg" [inlineSVG]="caminhoImg+comodoAtributoVariacao.imagem" [ngStyle]="{color: getSvgColor(comodoAtributoVariacao.id)}"></div>
                              </div>
                           </div>
                        </ng-template>
                     </owl-carousel-o>
                  </div>
                  <div class="infos">
                     <div class="name">
                        {{cliente.apartamento.nome}} - {{cliente.apartamento.planta.metragem.valor}}m²
                     </div>
                     <div class="room-options desktop">
                        <ul>
                           <li><a href="javascript:void(0)" (click)="shareModal(configuratorShareModal, configuratorSuccessModal)">Compartilhar <img src="assets/images/icon_compartilhar.png" alt="Compartilhar"></a></li>
                           <!--<li><a href="javascript:void(0)" (click)="saveModal(configuratorSuccessModal)">Salvar <img src="assets/images/icon_download.png" alt="Salvar"></a></li>-->
                           <li><a href="javascript:void(0)" (click)="checkModal(configuratorSuccessModal)">Imprimir <img src="assets/images/icon_imprimir.png" alt="Imprimir"></a></li>
                        </ul>
                     </div>
                  </div>
                  <div class="description">
                     <p>As imagens são meramente ilustrativas. O Cliente, ao preencher, os documentos concorda que as opções aqui selecionadas refletem suas opções na personalização de seu imóvel e de que não haverá alterações em suas escolhas até a entrega das chaves. O preenchimento desse documento é obrigatório até 21/02/2024. 
                        Os itens selecionáveis não apresentam custos adicionais para os clientes HALMA 199 (JFC 199 Empreendimento Imobiliario SPE Ltda - CNPJ 41.843.554/0001-38), com exceção dos móveis planejados em marcenaria que devem ser negociados diretamente com a Fábrica de Móveis Florense Ltda, com endereço na Av. Dr. Jesuíno Marcondes Machado 360, Nova Campinas, CEP 13092-108, Campinas, SP ou por contato telefone + 55 (19) 3251-4066</p>
                  </div>
                  <div class="room-options mobile">
                     <ul>
                        <li><a href="javascript:void(0)" (click)="shareModal(configuratorShareModal, configuratorSuccessModal)">Compartilhar <img src="assets/images/icon_compartilhar.png" alt="Compartilhar"></a></li>
                        <!--<li><a href="javascript:void(0)" (click)="saveModal(configuratorSuccessModal)">Salvar <img src="assets/images/icon_download.png" alt="Salvar"></a></li>-->
                        <li><a href="javascript:void(0)" (click)="checkModal(configuratorSuccessModal)">Imprimir <img src="assets/images/icon_imprimir.png" alt="Imprimir"></a></li>
                     </ul>
                  </div>
               </div>
            </div>
            
            <div class="col-lg-6 details-table">
               <div class="options">
                  <div class="div-table">
                     <div *ngFor="let comodo of getComodosBanheiroSala(); let i = index">
                        <div class="div-table-row room" [ngClass]="{'first': i === 0}" >
                           <div class="div-table-col rooms"><span class="title">{{comodo.nome === 'Sala' ? 'Ambientes Integrados' : comodo.nome}}</span></div>
                           <div class="div-table-col items">Itens</div>
                           <!--<div class="div-table-col value">Valores</div>-->
                        </div>
                        <div *ngFor="let comodoAtributo of getComodoAtributosByComodo(comodo.id); let j = index;">
                           <div *ngFor="let comodoAtributoVariacao of getComodoAtributoVariacaoBySession(comodoAtributo.id);" class="div-table-row" [ngClass]="{'first': j === 0}">
                              <div class="div-table-col">{{comodoAtributo.nome}}</div>
                              <div class="div-table-col items">
                                 {{comodoAtributoVariacao.nome}}
                                 <br/>
                                 <span *ngIf="!comodoAtributoVariacao.nome.includes('Cor Formica')"><p [innerHtml]="comodoAtributoVariacao.descricao"></p></span>
                                 <span *ngIf="comodoAtributoVariacao.nome.includes('Cor Formica')" style="color:#fff;padding: 5px 12px 2px;display:block;margin-top:5px;width:95px;" [style.background]="getColor(comodoAtributoVariacao.id)">{{getColor(comodoAtributoVariacao.id)}}</span>
                              </div>
                              <!--<div class="div-table-col value">{{somaPrecoUnitario(comodoAtributoVariacao) | currency: 'BRL': true}}</div>-->
                           </div>
                        </div>
                     </div>
                     <div class="div-table-row room">
                        <div class="div-table-col rooms"><span class="title">Complementares</span></div>
                        <div class="div-table-col items">Descrição</div>
                     </div>
                     <div *ngFor="let atributoAdicional of getAtributosAdicionais(); let k = index;">
                        <div class="div-table-row" [ngClass]="{'first': k === 0}">
                           <div class="div-table-col">{{atributoAdicional.nome}}</div>
                           <div class="div-table-col items"><p [innerHtml]="atributoAdicional.descricao"></p></div>
                           <!--<div class="div-table-col value">{{atributoAdicional.preco | currency: 'BRL': true}}</div>-->
                        </div>
                     </div>
                     <div class="div-table-row">
                        <div class="div-table-col">Fechadura Biométrica</div>
                        <div class="div-table-col items">Este item será entregue pela Halma Incorporadora, sem custos adicionais.</div>
                     </div>
                     <div class="div-table-row">
                        <div class="div-table-col">Forro de Gesso</div>
                        <div class="div-table-col items">Este item será entregue pela Halma Incorporadora, sem custos adicionais.</div>
                     </div>
                     <div class="div-table-row">
                        <div class="div-table-col">Nicho no Box (60L X 30H)</div>
                        <div class="div-table-col items">Este item será entregue pela Halma Incorporadora, sem custos adicionais.</div>
                     </div>
                  </div>
               </div>

               <div class="pdf-content" id="printContent" #printContent style="width: 100%;overflow: hidden;">
                  <table id="details" width="62%" style="font-size:14px;" border="0">
                     <br/><br/><br/><br/>
                     <img alt="DOM 436" src="assets/images/logo_dom436_black.png">
                     <br/><br/><br/><br/><br/><br/><br/><br/><br/><br/>
                     <h2 style="margin-top:30px;">{{cliente.apartamento.nome}}</h2>
                     <strong>Metragem: {{cliente.apartamento.planta.metragem.valor}}m²</strong>
                     <br/><br/><br/>
                     <!--
                     <h4>Valores:</h4>
                     <p>Apartamento: {{cliente.apartamento.preco | currency: 'BRL': true}}</p>
                     <p>Itens: {{cliente.valorBase | currency: 'BRL': true}}</p>
                     <p>Adicionais: {{cliente.valorAdicional | currency: 'BRL': true}}</p>
                     <p><strong>Total: {{cliente.valorTotal | currency: 'BRL': true}}</strong></p>
                     <br/><br/>
                     -->
                     <h4>Dados do Cliente:</h4>
                     <p>Cliente: {{cliente.nome}}</p>
                     <p>E-Mail: {{cliente.email}}</p>
                     <p>Telefone: {{cliente.celular}}</p>
                     <br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/>
                     <br/><br/><br/><br/>
                     <div *ngFor="let comodo of getComodosBanheiroSala(); let i = index">
                        <h5 style="clear:both; padding-top:40px;">{{comodo.nome === 'Sala' ? 'Ambientes Integrados' : comodo.nome}}</h5>
                        <div style="width:100%; border-bottom: 1px solid #000; border-top: 1px solid #000; display: block; padding: 0 3px; height: 40px;">
                           <div style="float:left; width:30%; padding:10px 0;">Item</div>
                           <div style="float:left; width:50%; padding:10px 0;">Opção</div>
                           <!--<div style="float:left; width:20%; padding:10px 0; text-align:right;">Valor</div>-->
                        </div>
                        <div *ngFor="let comodoAtributo of getComodoAtributosByComodo(comodo.id); let j = index;">
                           <div *ngFor="let comodoAtributoVariacao of getComodoAtributoVariacaoBySession(comodoAtributo.id);">
                              <div style="float:left; width: 30%; padding: 15px 3px 10px;">{{comodoAtributo.nome}}</div>
                              <div style="float:left; width: 50%; padding: 15px 3px 10px;">{{comodoAtributoVariacao.nome.includes('Cor Formica') ? 'Cor: '+getColor(comodoAtributoVariacao.id) : comodoAtributoVariacao.descricao}}</div>
                              <!--<div style="float:left; width: 20%; padding: 15px 3px 10px; text-align:right;">{{somaPrecoUnitario(comodoAtributoVariacao) | currency: 'BRL': true}}</div>-->
                           </div>
                        </div>
                     </div>
                     <div *ngIf="cliente.valorAdicional > 0">
                        <h5 style="clear:both; padding-top:40px;">Atributos Adicionais</h5>
                        <div style="width:100%; border-bottom: 1px solid #000; border-top: 1px solid #000; display: block; padding: 0 3px; height: 40px;">
                           <div style="float:left; width:30%; padding:10px 0;">Item</div>
                           <div style="float:left; width:50%; padding:10px 0;">Opção</div>
                           <div style="float:left; width:20%; padding:10px 0; text-align:right;">Valor</div>
                        </div>
                        <div *ngFor="let atributoAdicional of getAtributosAdicionais(); let k = index;" style="display: block; width: auto; clear: both;">
                           <div style="float:left; width: 30%; padding: 15px 3px 10px;">{{atributoAdicional.nome}}</div>
                           <div style="float:left; width: 50%; padding: 15px 3px 10px;"><p [innerHtml]="atributoAdicional.descricao"></p></div>
                           <div style="float:left; width: 20%; padding: 15px 3px 10px; text-align:right;">{{atributoAdicional.preco | currency: 'BRL': true}}</div>
                        </div>
                     </div>
                  </table>
                  
               </div>
         
               <div *ngIf="!cadastroSalvo" class="buttons-bottom">
                  <div class="back-configurator">
                     <div class="button desktop">
                        <a [routerLink]="['/decorar-apartamento']"><img alt='Seta' src='assets/images/arrow-left-black.png' /> Voltar para o configurador</a>
                     </div>
                     <div class="button mobile">
                        <a [routerLink]="['/decorar-apartamento']"> Voltar</a>
                     </div>
                  </div>
                  <div class="confirm-button">
                     <div class="button">
                        <a href="javascript:void(0)" (click)="openModal(configuratorSuccessModal)">Obter proposta</a>
                     </div>
                     <!--
                     <div class="button simulator">
                        <a href="javascript:void(0)" (click)="openModal(configuratorSimulatorModal)">Simular Financiamento</a>
                     </div>
                     -->
                     <div class="room-options">
                        <ul>
                           <li><a href="javascript:void(0)" (click)="shareModal(configuratorShareModal, configuratorSuccessModal)">Compartilhar <img src="assets/images/icon_compartilhar.png" alt="Compartilhar"></a></li>
                           <!--<li><a href="javascript:void(0)" (click)="saveModal(configuratorSuccessModal)">Salvar <img src="assets/images/icon_download.png" alt="Salvar"></a></li>-->
                           <li><a href="javascript:void(0)" (click)="checkModal(configuratorSuccessModal)">Imprimir <img src="assets/images/icon_imprimir.png" alt="Imprimir"></a></li>
                        </ul>
                     </div>
                  </div>
               </div>
               <div *ngIf="cadastroSalvo" class="buttons-bottom">
                  <div class="back-configurator">
                     <div class="button desktop">
                        <a [routerLink]="['/decorar-apartamento', cliente.codigoUrl]"><img alt='Seta' src='assets/images/arrow-left-black.png' /> Voltar para o configurador</a>
                     </div>
                     <div class="button mobile">
                        <a [routerLink]="['/decorar-apartamento', cliente.codigoUrl]"> Voltar</a>
                     </div>
                  </div>
                  <div class="confirm-button">
                     <div class="button">
                        <a href="javascript:void(0)" (click)="confirmConfiguration(); openModal(configuratorSuccessModal)">Confirmar Configuração</a>
                     </div>
                     <div class="room-options saved">
                        <ul>
                           <li><a href="javascript:void(0)" (click)="shareModal(configuratorShareModal, configuratorSuccessModal)">Compartilhar <img src="assets/images/icon_compartilhar.png" alt="Compartilhar"></a></li>
                           <!--<li><a href="javascript:void(0)" (click)="saveModal(configuratorSuccessModal)">Salvar <img src="assets/images/icon_download.png" alt="Salvar"></a></li>-->
                           <li><a href="javascript:void(0)" (click)="checkModal(configuratorSuccessModal)">Imprimir <img src="assets/images/icon_imprimir.png" alt="Imprimir"></a></li>
                        </ul>
                     </div>
                  </div>
               </div>
            </div>
         </div>
         <div class="col-lg-12">
            <!--
            <div class="logo-footer">
               <img alt='DOM 436' src='assets/images/logo_dom436_black.png' />
            </div>
            -->
         </div>
      </div>
   </div>
</div>

<ng-template #configuratorSuccessModal>
   <div class="modal-body page-configurator-success">
      <button type="button" class="close" aria-label="Close" (click)="modalRef.hide()"> X </button>
      <div *ngIf="cadastroSalvo" class="success">
         <h1 class="title">Parabéns!</h1>
         <p class="description">Você completou a decoração do seu apartamento com sucesso e receberá um link diretamente no email cadastrado, para acessar o seu apartamento decorado sempre que quiser.</p>
      </div>
      <div *ngIf="!cadastroSalvo" class="success">
         <h1 class="title">Falta pouco!</h1>
         <p class="description">Cadastre-se para entrar em contato<br/>e salvar seu novo apartamento</p>
         <form class="success-form" id="registerform" #form="ngForm">
            <div class="form-group">
               <dom436-input errorMessage="Campo obrigatório e com no mínimo 4 caracteres" label="Nome completo">
                  <input type="text" name="nome" ngModel required minlength="4" autocomplete="off" class="form-control" placeholder="Nome Sobrenome *">
            </dom436-input>
            </div>
            <div class="form-group">
               <dom436-input errorMessage="Campo obrigatório e possuir padrão de e-mail válido" label="E-Mail">
                  <input type="email" name="email" ngModel email required autocomplete="off" class="form-control" placeholder="nome@exemplo.com.br *">
            </dom436-input>
            </div>
            <div class="form-group">
               <dom436-input errorMessage="" label="Celular">
                  <input type="text" name="celular" ngModel autocomplete="off" class="form-control" placeholder="(19) 99900-0000" mask="(00) 00000-0000">
            </dom436-input>
            </div>
            <button type="submit" (click)="salvarCliente(form.value)" [disabled]="!form.valid" class="btn btn-primary">Enviar</button>    
            <div class="campos-obrigatorios">
               <small *ngIf="!form.valid">* Preencha todos os campos obrigatórios.</small>
            </div>
         </form>
      </div>
   </div>
</ng-template>

<ng-template #configuratorShareModal>
   <div class="modal-body page-configurator-success">
      <button type="button" class="close" aria-label="Close" (click)="modalRef.hide()"> X </button>
      <div class="success-form share">
         <h1 class="title">Compartilhar</h1>
         <p class="description">Copie o link abaixo para compartilhar o seu apartamento decorado.</p>
         <input type="text" value="{{getCurrentUrl()}}" #myLink>
         <button (click)="copyLink(myLink)" class="btn btn-primary">Copiar</button>
      </div>
   </div>
</ng-template>

<ng-template #configuratorSimulatorModal>
   <div class="modal-body page-configurator-success">
      <button type="button" class="close" aria-label="Close" (click)="modalRef.hide()"> X </button>
      <h1 class="title">Simulador Online</h1>
         <p class="description">Simule aqui o financiamento<br/>do seu novo apartamento</p>
         <div class="success-form simulator">
            <div class="form-group">
               <label>Valor da Entrada</label>
               <input type="text" name="entrada" required autocomplete="off" class="form-control" (blur)="setSimuladorEntrada($event)" [(ngModel)]="simuladorEntrada" placeholder="Valor da Entrada *" currencyMask [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }">
            </div>
            <div class="form-group">
               <label>Prazo (Anos)</label>
               <input type="number" name="prazo" required autocomplete="off" class="form-control" (blur)="setSimuladorPrazo($event)" [(ngModel)]="simuladorPrazo" placeholder="Prazo (Anos) *">
            </div>
            <button type="submit" (click)="getSimuladorValoresTotais()" class="btn btn-primary">Calcular</button>    
            <div class="results">
               <p class="title"><strong>Valores do Financiamento:</strong></p>
               <p>Valor das Parcelas: {{simuladorValorParcelas | currency: 'BRL': true}}</p>
               <p>Valor Total das Parcelas: {{simuladorValorTotalParcelas | currency: 'BRL': true}}</p>
               <p>Valor Final do Apartamento: {{simuladorValorFinalApartamento | currency: 'BRL': true}}</p>
            </div>
         </div>
   </div>
</ng-template>